<template>
  <div class="main-body home-manage-container">
    <el-row>
      <el-col :span="12">
        <el-card
          :body-style="{
            height: '40vh',
          }"
          v-loading="tileLoadingFlag"
        >
          <template #header>
            <span style="font-weight: bold;">底图权限预览</span>
          </template>
          <el-scrollbar>
            <el-collapse v-model="activeVal">
              <el-collapse-item :name="`${1 + index}`"
                v-for="(tile, index) in dataList"
                :key="index"
              >
                <template #title>
                  <el-tag type="primary">{{ tile['layerType'] }}</el-tag>
                  &nbsp;&nbsp;
                  <el-text type="info">{{ tile['layerName'] }}</el-text>
                </template>
                <template #default>
                  <div v-for="(user, userIndex) of tile['allocateUser']"
                    :key="userIndex"
                  >
                    <el-card shadow="always"
                      :body-style="{
                        padding: '0.3125rem',
                      }"
                    >
                      <el-row>
                        <el-col :span="14">
                          {{ user['userName'] }}
                        </el-col>
                        <el-col :span="6"
                          :style="{
                            textAlign: 'center',
                          }"
                        >
                          {{ user['effectiveTime'] }}
                        </el-col>
                        <el-col :span="4"
                          :style="{
                            textAlign: 'center',
                          }"
                        >
                          <el-button type="danger"
                            size="small"
                            @click="deleteFn(tile, user)"
                          >删除</el-button>
                        </el-col>
                      </el-row>
                    </el-card>
                  </div>
                </template>
              </el-collapse-item>
            </el-collapse>
          </el-scrollbar>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive, markRaw,
  h, defineComponent, toRaw,
} from 'vue';
import store from '@/store';
import { isNull, dayjs, message, vueCreateAppInit } from '@/utils/js/initVariable';

import { ElMessageBox } from 'element-plus';
import {
  queryFootPrintMapAllocateList, modifyAllocateList,
} from '@/api/MapManage';

// props
const props = defineProps({
  
});
// emit
const emit = defineEmits([
  
]);

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  queryFootPrintMapAllocateListFn();
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

const deleteFn = (tile, user)=>{
  // console.log(tile, user);
  ElMessageBox.confirm(
    '是否删除当前底图权限？',
    '删除底图权限',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(res=>{
    modifyAllocateList({
      userId: user.userId,
      id: tile.id,
    }).then(res=>{
      if(res.data.code == 1004){
        message(res.data.msg, 1);
        queryFootPrintMapAllocateListFn();
      }
    }).catch(err=>{
      console.log(err);
    });
  }).catch(err=>{
    console.log(err);
  });
}

const activeVal = ref([  ]), tileLoadingFlag = ref(false);
const dataList = ref([ ]);

const queryFootPrintMapAllocateListFn = ()=>{
  tileLoadingFlag.value = true;
  queryFootPrintMapAllocateList({}).then(res=>{
    if(res.data.code == 1004){
      dataList.value = res.data.array;
    }
    tileLoadingFlag.value = false;
  }).catch(err=>{
    tileLoadingFlag.value = false;
    console.log(err);
  });
}

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.home-manage-container{
  padding: 10px;
  :deep(.el-collapse){
    .el-collapse-item__content{
      padding-bottom: 0;
      padding: var(--padDefaultSize);
      display: flex;
      flex-direction: column;
      gap: 5px;
    }
  }
}
</style>